module.exports = __webpack_public_path__ + "media/images/98labs-822485e401117b3b3677a19d61eb0e21.png";